import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store/store'
import VueResource from 'vue-resource'
import { unomiApis } from '../services/ApiServices/unomiApis'

Vue.use(VueResource)

/* 404 Page Component */
const PageNotFound = () => import('@/components/pages/404Page/404page')
const MainApp = () => import('@/components/MainApp')
const Home = () => import('@/components/pages/home/Home')
const PaymentPage = () => import('@/components/pages/PaymentPage')
const BankLogin = () => import('@/components/pages/login/BankLoginPage')
const TenantRegistration = () => import('@/components/pages/tenant/TenantRegistration')
// const vendorPlan = () => import('@/components/pages/vendor/vendorPlan');
const vendorPlan = () => import('@/components/pages/vendor/plans/vendorPlan2')
const subscriptionPayment = () => import('@/components/pages/paymentGateway/razorPay/RazorPayWebIntegrationSubscription')
// const VendorGstPage = () => import('@/components/pages/vendor/vendorGstPage');
const ComingSoon = () => import('@/components/pages/comingSoon/ComingSoon')
const User = () => import('@/components/pages/user/User')
const UserProfile = () => import('@/components/pages/user/userPages/Profile')
const Addresses = () => import('@/components/pages/user/userPages/Addresses')
const Orders = () => import('@/components/pages/user/userPages/Orders')
const SavedCards = () => import('@/components/pages/paymentGateway/stripe/StripePaymentGateway')
const GiftCard = () => import('@/components/pages/user/userPages/GiftCard')
const Privacy = () => import('@/components/shared/footer/pages/Privacy')
const AboutUs = () => import('@/components/shared/footer/pages/AboutUs')
const ContactUs = () => import('@/components/shared/footer/pages/ContactUs')
const TermsAndConditions = () => import('@/components/shared/footer/pages/TermsAndConditions')
// const vendorSignUp = () => import('@/components/shared/pages/vendorSignUp');
const vendorDashboard = () => import('@/components/pages/vendor/dashboard/VendorDashboard')
const vendorDashboardView = () => import('@/components/pages/vendor/vendorStore/VendorDashboardView')
const vendorProductListing = () => import('@/components/pages/vendor/vendorStore/pages/vendorProductListing')
const vendorOrderListing = () => import('@/components/pages/vendor/vendorStore/pages/vendorOrderListing')
// const ExistingCustomerVendorLogin = () => import('@/components/pages/vendor/ExistingCustomerVendorLoginPage');
// const TenantLogin = () => import('@/components/shared/pages/TenantLogin');
const WishList = () => import('@/components/pages/user/userPages/WishList')
const OrderTracking = () => import('@/components/pages/user/userPages/order/OrderTracking')
const OrderRating = () => import('@/components/pages/user/userPages/order/widgets/OrderRating')
const OrderReturn = () => import('@/components/pages/user/userPages/order/widgets/OrderReturn')
const OrderedProductsListing = () => import('@/components/pages/user/userPages/pages/OrderedProducts')
const OrderedGiftCardsListing = () => import('@/components/pages/user/userPages/pages/OrderedGiftCards')

const ProductDetails = () => import('@/components/pages/productDetails/ProductDetails')
const VendorListing = () => import('@/components/pages/productDetails/container/vendorList/pages/VendorListing')
const ProductVariantListing = () => import('@/components/pages/productDetails/container/variants/pages/ProductVariantListing')
const LoginPage = () => import('@/components/pages/login/LoginPage')
// const VendorPage = () => import('@/components/pages/vendor/VendorPage')
const AgentPage = () => import('@/components/pages/Agent/AgentHome')
// const AgentLoginPage = () => import('@/components/pages/Agent/AgentLoginPage')
const AgentDashBoard = () => import('@/components/pages/Agent/dashboard/AgentDashBoard')
// const AgentLoginPage = () => import('@/components/pages/Agent/newAgent/AgentLoginPage');
const SignUpPage = () => import('@/components/pages/signUp/SignUp')
const Cart = () => import('@/components/pages/cart/Cart')
const ProductList = () => import('@/components/pages/productListing/ProductListing')
const CheckoutPage = () => import('@/components/pages/checkout/Checkout')
const OrderSuccess = () => import('@/components/pages/successPage/OrderSuccess')
const ResetPassword = () => import('@/components/pages/resetPassword/ResetPassword')
const ForgotPassword = () => import('@/components/pages/resetPassword/ForgotPassword')
const UserAccount = () => import('@/components/pages/user/userPages/Account')
Vue.use(Router)

const userPaths = [
	{
		path: 'wish-list',
		name: 'WishList',
		component: WishList,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: 'profile',
		name: 'UserProfile',
		component: UserProfile,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: 'account',
		name: 'UserAccount',
		component: UserAccount,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: 'orders',
		name: 'Orders',
		component: Orders,
		children: [
			{
				path: '/user/order/orderedProducts',
				name: 'orderedProductsListing',
				component: OrderedProductsListing
			},
			{
				path: '/user/order/orderedGiftCards',
				name: 'orderedGiftCardsListing',
				component: OrderedGiftCardsListing
			}
		],
		redirect: { name: 'orderedProductsListing' },
		meta: {
			requiresAuth: true
		}
	},
	{
		path: 'addresses',
		name: 'Addresses',
		component: Addresses,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: 'giftCards',
		name: 'GiftCard',
		component: GiftCard,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: 'saved-cards',
		name: 'SavedCards',
		component: SavedCards,
		meta: {
			requiresAuth: true
		}
	}
]

const staticPaths = [
	{
		path: '/reset-password/:token',
		name: 'ResetPassword',
		component: ResetPassword,
		meta: {
			title: 'Reset your password',
			description: '',
			keywords: ''
		}
	},
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/payment-page',
		name: 'PaymentPage',
		component: PaymentPage
	},
	{
		path: '/bank-login',
		name: 'BankLogin',
		component: BankLogin
	},
	{
		path: '/tenant-registration',
		name: 'TenantRegistration',
		component: TenantRegistration
	},
	{
		path: '/vendorPlan',
		name: 'vendorPlan',
		component: vendorPlan,
		meta: {
			requiresVendorAuth: true
		}
	},
	{
		path: '/vendorSubscriptionPayment',
		name: 'subscriptionPayment',
		component: subscriptionPayment,
		meta: {
			requiresVendorAuth: true
		}
	},
	// {
	//   path: '/vendorGst',
	//   name: 'vendorGstPage',
	//   component: VendorGstPage,
	//   meta: {
	//     requiresVendorAuth: true,
	//   },
	// },
	{
		path: '/pages/vendordashboard',
		name: 'VendorDashboard',
		component: vendorDashboard,
		meta: {
			requiresVendorAuth: true
		}
	},
	// {
	//   path: '/ExistingVendorSignup',
	//   name: 'ExistingCustomerVendorLogin',
	//   component: ExistingCustomerVendorLogin,
	// },
	{
		path: '/user/orders/orderTracking',
		name: 'OrderTracking',
		component: OrderTracking,
		meta: {
			title: 'Order Tracking',
			description: '',
			keywords: ''
		}
	},
	{
		path: '/user/orders/orderRating',
		name: 'OrderRating',
		component: OrderRating,
		meta: {
			requiresAuth: true
		}
		// props: true,
	},
	{
		path: '/user/orders/orderReturn',
		name: 'orderReturn',
		component: OrderReturn,
		meta: {
			requiresAuth: true
		}
		// props: true,
	},
	{
		path: '/login',
		name: 'LoginPage',
		component: LoginPage
	},
	{
		path: '/forgotPassword',
		name: 'ForgotPassword',
		component: ForgotPassword
	},
	{
		path: '/vendorLogin',
		name: 'VendorPage',
		component: TenantRegistration
	},
	// {
	// 	path: '/agentLogin',
	// 	name: 'AgentLoginPage',
	// 	component: AgentLoginPage
	// },
	{
		path: '/agentSignUp',
		name: 'AgentPage',
		component: AgentPage
	},
	{
		path: '/cart',
		name: 'Cart',
		component: Cart
	},
	{
		path: '/coming-soon',
		name: 'ComingSoon',
		component: ComingSoon
	},
	{
		path: '/product_description',
		name: 'ProductDetails',
		component: ProductDetails,
		meta: {
			title: 'Product Description',
			description: 'A paragraph is a self-contained unit of a discourse ',
			keywords: 'good'
		}
	},
	{
		path: '/product_description/vendorListing',
		name: 'VendorListing',
		component: VendorListing
	},
	{
		path: '/product_description/productVariantListing',
		name: 'ProductVariantListing',
		component: ProductVariantListing
	},
	{
		path: '/signup',
		name: 'SignUp',
		component: SignUpPage
	},
	{
		path: '/product-list',
		name: 'ProductList',
		component: ProductList
	},
	{
		path: '/search-results',
		name: 'SearchResults',
		component: ProductList
	},
	{
		path: '/brand-products-list',
		name: 'BrandProducts',
		component: ProductList
	},
	{
		path: '/recommend-products',
		name: 'RecommendProducts',
		component: ProductList
	},
	{
		path: '/user',
		name: 'User',
		redirect: { name: 'UserProfile' },
		component: User,
		children: userPaths,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/checkout',
		name: 'CheckoutPage',
		component: CheckoutPage,
		meta: {
			requiresAuth: true
		}
	},
	{
		name: 'AllProducts',
		path: '/all-products',
		component: ProductList
	},
	{
		path: '/order-success',
		name: 'OrderSuccess',
		component: OrderSuccess,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/promotional_product-list',
		name: 'ProductListPromotion',
		component: ProductList
	},
	{
		path: '/pages/terms',
		name: 'TermsAndConditions',
		component: TermsAndConditions
	},
	{
		path: '/pages/privacy',
		name: 'Privacy',
		component: Privacy
	},
	{
		path: '/pages/about',
		name: 'AboutUs',
		component: AboutUs
	},
	{
		path: '/pages/contact',
		name: 'ContactUs',
		component: ContactUs
	},
	// {
	//   path: '/pages/vendorSignup',
	//   name: 'SellerLogin',
	//   component: vendorSignUp,
	// },
	{
		path: '/pages/vendordashboard/view',
		name: 'vendorDashboardView',
		component: vendorDashboardView,
		children: [
			{
				path: '/vendor/vendorProductListing',
				name: 'vendorProductListing',
				component: vendorProductListing
			},
			{
				path: '/vendor/vendorOrderListing',
				name: 'vendorOrderListing',
				component: vendorOrderListing
			}
		],
		redirect: { name: 'vendorProductListing' },
		meta: {
			requiresVendorAuth: true
		}
	},
	// {
	//     path: '/pages/TenantLogin',
	//     name: 'TenantLogin',
	//     component: TenantLogin,
	// },
	{
		path: '/agent/dashboard',
		name: 'AgentDashBoard',
		component: AgentDashBoard,
		meta: {
			requiresAgentAuth: true
		}
	}
]

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			name: 'PageNotFound',
			meta: {
				title: '404',
				nosubmenu: true,
				noauth: true,
				noheader: true,
				nofooter: true
			},
			component: PageNotFound
		},
		{
			path: '/',
			component: MainApp,
			children: staticPaths
		}
	],
	scrollBehavior (to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})

/* Route Nav Guard */
router.beforeEach((to, from, next) => {
	// Check for requiresAuth guard
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// Check if NO logged user
		if (to.path === '/checkout') {
			if (store.state.user.loginStatus === false) {
				next({ path: '/login', query: { next_to: 'checkOut' } })
			} else {
				next()
			}
		} else if (to.path === '/cart') {
			if (store.state.user.loginStatus === false) {
				next({ path: '/login', query: { next_to: 'cart' } })
			} else {
				next()
			}
		} else if (to.path === '/user/account') {
			if (store.state.user.loginStatus === false) {
				next({ path: '/login', query: { next_to: 'user' } })
			} else {
				next()
			}
		} else if (to.path === '/user/giftCards') {
			if (store.state.user.loginStatus === false) {
				next({ path: '/login', query: { next_to: 'GiftCard' } })
			} else {
				next()
			}
		} else if (to.path === '/user/orders') {
			if (store.state.user.loginStatus === false) {
				next({ path: '/login', query: { next_to: 'orders' } })
			} else {
				next()
			}
		} else if (to.path === '/user/wish-list') {
			if (store.state.user.loginStatus === false) {
				next({ path: '/login', query: { next_to: 'wishList' } })
			} else {
				next()
			}
		} else if (to.path === '/user/orders/orderRating') {
			if (store.state.user.loginStatus === false) {
				next({ path: '/login', query: { next_to: 'orderRating' } })
			} else {
				next()
			}
		} else if (store.state.user.loginStatus === false) {
			// Go to login
			next({
				path: '/'
				// query: {
				//   redirect: to.fullPath,
				// },
			})
		} else {
			// Proceed to route
			next()
		}
	} else if (to.matched.some(record => record.meta.requiresVendorAuth)) {
		if (to.path === '/vendorPlan') {
			if (store.state.vendor.vendorAuthenticated === false) {
				next({ path: '/vendorLogin', query: { next_to: 'vendorPlan' } })
			} else {
				next()
			}
		} else if (to.path === '/subscriptionPayment') {
			if (store.state.vendor.vendorAuthenticated === false) {
				next({ path: '/vendorLogin', query: { next_to: 'subscriptionPayment' } })
			} else {
				next()
			}
		} else if (to.path === '/vendorGst') {
			if (store.state.vendor.vendorAuthenticated === false) {
				next({ path: '/vendorLogin', query: { next_to: 'vendorGst' } })
			} else {
				next()
			}
		} else {
			next()
		}
	} else if (to.matched.some(record => record.meta.requiresAgentAuth)) {
		if (to.path === '/agent/dashboard') {
			if (store.state.agent.agentAuthenticated === false) {
				next({ path: '/agentSignUp' })
			} else {
				next()
			}
		}
	} else {
		// Proceed to route
		next()
	}
})

router.beforeEach((to, from, next) => {
	if (to.path !== '/product-list' &&
        to.path !== '/search-results' &&
        to.path !== '/promotional_product-list' &&
        to.path !== '/product_description') {
		document.title = 'Neo Bank'
		next()
	}
	next()
})

router.beforeEach((to, from, next) => {
	if (to.path !== '/checkout' && to.path !== '/order-success') {
		store.dispatch('charges/setShippingCharge', 0)
		store.dispatch('charges/setTax', 0)
		store.dispatch('charges/setShowCharge', false)
		store.dispatch('buynow/updateGiftCardQuantity')
		store.dispatch('cart/updateGiftCardCartQuantity')
		next()
	}
	next()
})

router.beforeEach((to, from, next) => {
	const viewConfig = [
		{ key: 'electronics', value: 'groceryViewEvent' },
		{ key: 'men', value: 'menFashionViewEvent' },
		{ key: 'home-appliances', value: 'womenFashionViewEvent' }
	]
	let itemTypeId = 'ECOM_EVENT_TYPE'
	for (let viewData of viewConfig) {
		if (to.fullPath.includes(viewData.key)) {
			itemTypeId = viewData.value
			break
		}
	}
	const eventData = {
		eventType: 'ECOM_PAGE_VISIT',
		scope: 'ECOMMERCE',
		source: {
			itemId: from.name
		},
		target: {
			itemId: itemTypeId,
			reffedUrl: to.fullPath
		}
	}
	unomiApis.postEvents(eventData)
	next()
})

export default router
